import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

const EMAIL_KEY = "emailForSignIn";

export async function storeEmailForSignIn(email: string) {
  const value = email.trim().toLowerCase();
  if (Platform.OS === "web") {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(EMAIL_KEY, value);
    }
    return;
  }
  await AsyncStorage.setItem(EMAIL_KEY, value);
}

export async function readEmailForSignIn(): Promise<string | null> {
  if (Platform.OS === "web") {
    return typeof localStorage !== "undefined" ? localStorage.getItem(EMAIL_KEY) : null;
  }
  return AsyncStorage.getItem(EMAIL_KEY);
}

export async function clearEmailForSignIn() {
  if (Platform.OS === "web") {
    if (typeof localStorage !== "undefined") localStorage.removeItem(EMAIL_KEY);
    return;
  }
  await AsyncStorage.removeItem(EMAIL_KEY);
}
